import React, {useEffect, useState, useRef} from "react";

const EditClinicEmailTemplate = () => {

};

export default EditClinicEmailTemplate;